export default "__VITE_ASSET__HHSvw_qL__"